<template>
  <div
    :class="indexBGshow ? 'indexBg' : ''"
    style="
      width: 100%;
      height: 900px;
      background-size: cover;
      position: relative;
    "
  >
    <!-- <div class="Counttext LR_center">
      <div class="header_text">{{HeaderCount.productName}}</div>
      <div class="header_icon" v-for="(item,index) in HeaderCount.priceList" :key="index">{{item}}</div>
    </div>-->
    <!-- <div
      :class="{'border-bottom':$route.path.includes('queryPrice')}"
      style="z-index: 9; position: fixed;top: 0;width: 100%;"
      :style="
        $store.state.setType
          ? $store.state.headType === 1
          ? 'background:#FF4D01;color:#ffffff' : 'background:#FFFFFF;color:#141414'
          : 'background:rgba(0, 0, 0, 0.03);color:#ffffff'
      "
      @mouseenter="headEnter"
    > -->
    <div
      :class="{'border-bottom':$route.path.includes('queryPrice') || $store.state.setType}"
      style="z-index: 9; position: fixed;top: 0;width: 100%;"
      :style="
        $store.state.setType
          ? 'background:#FFFFFF;color:#141414;'
          : 'background:rgba(0, 0, 0, 0.03);color:#ffffff'
      "
      @mouseenter="headEnter"
    >
      <!-- max-width: 1098px; -->
      <div
        class="header"
        :class="routerType ? 'showType' : 'page-padding__min-width'"
        :style="routerType ? 'max-width:100%' : 'max-width:1200px;'"
      >
        <div class="wrap_l" style="cursor: pointer" @click="pathIndex()">
          <img style="float: left; width: 116px" :src="!$store.state.setType ? require('@/assets/logoWith.png') : require('@/assets/logo.png')" alt="Logo" />
          <div style="width: 1px;height: 16px;background: #fff;margin-right: 9px;" :class="!$store.state.setType ? '' : 'back_black'"></div>
          <span style="font-size: 16px;font-family: Source Han Sans CN;" :class="!$store.state.setType ? '' : 'color_black'">全球专线联盟旗下业务交互平台</span>
        </div>
        <div class="wrap_R">
          <!-- <div @click="myclick()" class="center_Style" style="margin-left: 30px; font-weight: bold">
            <span>全国服务热线 400-992-1818</span>
          </div> -->
          <div @mouseleave="tabMouseLeave">
            <div
              class="activeWrap"
              :class="{
              'activeStyle': $store.state.activeType == 1,
              'activeStyle_Primary': $store.state.activeType == 1 && $store.state.setType,
              'hover-bg-white': !$store.state.setType,
              'hover-bg-primary': $store.state.setType
            }"
              @click="shouType(1)"
              @mouseenter="tabMouseEnter(1)"
            >
              首页
              <span :class="$store.state.activeType == 1 ? 'navActive' : ''"></span>
            </div>
            <div
              class="activeWrap"
              :class="{
              'activeStyle': $store.state.activeType == 6,
              'activeStyle_Primary': $store.state.activeType === 6 && $store.state.setType,
              'hover-bg-white': !$store.state.setType,
              'hover-bg-primary': $store.state.setType
            }"
              @click="shouType(6)"
              @mouseenter="tabMouseEnter(6)"
            >
              专线大厅
              <span :class="$store.state.activeType == 6 ? 'navActive' : ''"></span>
            </div>
            <!-- <div
            class="activeWrap"
            :class="{
              'activeStyle': $store.state.activeType == 15 && $store.state.headType !== 2,
              'activeStyle_Primary': $store.state.activeType === 15 && $store.state.headType === 2,
              'hover-bg-white': $store.state.headType === 1,
              'hover-bg-primary': $store.state.headType === 2
            }"
            @click="shouType(15)"
            @mouseenter="tabMouseEnter(15)"
          >
            整柜询盘
            <span :class="$store.state.activeType == 15 ? 'navActive' : ''"></span>
          </div> -->
          <!--          <div-->
          <!--            class="activeWrap"-->
          <!--            :class="$store.state.activeType == 11 ? 'activeStyle' : ''"-->
          <!--            @click="shouType(11)"-->
          <!--          >-->
          <!--            品牌介绍-->
          <!--            <span :class="$store.state.activeType == 11 ? 'navActive' : ''"></span>-->
          <!--          </div>-->
<!--          <div-->
<!--            class="activeWrap"-->
<!--            :class="$store.state.activeType == 12 ? 'activeStyle' : ''"-->
<!--            @click="shouType(12)"-->
<!--          >-->
<!--            新闻中心-->
<!--            <span :class="$store.state.activeType == 12 ? 'navActive' : ''"></span>-->
<!--          </div>-->
          <div
            class="activeWrap"
            :class="{
              'activeStyle': $store.state.activeType == 3,
              'activeStyle_Primary': $store.state.activeType === 3 && $store.state.setType,
              'hover-bg-white': !$store.state.setType,
              'hover-bg-primary': $store.state.setType
            }"
              @click="shouType(3)"
              @mouseenter="tabMouseEnter(3)"
            >
              平台介绍
              <span :class="$store.state.activeType == 3 ? 'navActive' : ''"></span>
            </div>
            <div
              class="activeWrap"
              :class="{
              'activeStyle': $store.state.activeType == 2,
              'activeStyle_Primary': $store.state.activeType === 2 && $store.state.setType,
              'hover-bg-white': !$store.state.setType,
              'hover-bg-primary': $store.state.setType
            }"
              @click="shouType(2)"
              @mouseenter="tabMouseEnter(2)"
            >
              轨迹查询
              <span :class="$store.state.activeType == 2 ? 'navActive' : ''"></span>
            </div>
            <!-- <div
              class="activeWrap"
              :class="$store.state.activeType == 4 ? 'activeStyle' : ''"
              @click="shouType(4)"
            >
              用户指南
              <span :class="$store.state.activeType == 4 ? 'navActive' : ''"></span>
            </div> -->
            <div
              class="activeWrap"
              :class="{
              'activeStyle': $store.state.activeType === 7,
              'activeStyle_Primary': $store.state.activeType === 7 && $store.state.setType,
              'hover-bg-white': !$store.state.setType,
              'hover-bg-primary': $store.state.setType
            }"
              @click="shouType(7)"
              @mouseenter="tabMouseEnter(7)"
            >
              平台入驻
              <span :class="$store.state.activeType == 7 ? 'navActive' : ''"></span>
            </div>
            <el-popover
              width="1200"
              placement="bottom-end"
              trigger="hover"
              :visible-arrow="false"
              content=""
              title=""
              popper-class="service-list"
              :offset="277"
            >
              <div
                slot="reference"
                class="activeWrap"
                :class="{
                'activeStyle': [8,13,14].includes($store.state.activeType),
                'activeStyle_Primary': [8,13,14].includes($store.state.activeType) && $store.state.setType,
                'hover-bg-white': !$store.state.setType,
                'hover-bg-primary': $store.state.setType
              }"
                @mouseenter="tabMouseEnter(8)"
              >
                增值服务
                <i class="el-icon-arrow-down"></i>
                <!--<img
                  :src="ossPath + '/pages/home/icon_dropdown_grey.png'"
                  alt=""
                  v-if="($store.state.headType === 2 && ![8,14].includes($store.state.activeType)) || ($store.state.headType === 1 && [13].includes($store.state.activeType))">
                <img :src="ossPath + '/pages/home/icon_dropdown.png'" alt="" v-else>-->
                <span class="tag-hot">
                <img :src="ossPath + '/pages/home/icon_hot.png'" alt="">
              </span>
                <span :class="[8,13,14].includes($store.state.activeType) ? 'navActive' : ''"></span>
              </div>
              <div class="value-add-title">增值服务</div>
              <div class="value-add-divider"></div>
              <div class="value-add-service-list">
                <div
                  class="menu-item"
                  v-for="item in valueAddedServiceMenuList"
                  :key="item.name"
                  @click="clickMenu(item)">
                  <img :src="item.icon" alt="" style="width: 60px;height: 60px;margin-right: 10px;">
                  <div>
                    <div class="menu-item-title">{{ item.name }}</div>
                    <div class="menu-item-describe">
                      {{ item.describe }}
                      <el-link style="padding-top: 1px; text-decoration-line: none; color: #2B62ED; vertical-align: text-top" v-if="item.link" type="primary" :underline="false">
                        查看详情<el-icon name="arrow-right"></el-icon>
                      </el-link>
                    </div>
                  </div>
                </div>
              </div>
            </el-popover>
            <!--<div
              class="activeWrap"
              :class="$store.state.activeType == 8 ? 'activeStyle_Primary' : ''"
              @click="shouType(8)"
            >
              供应链金融
              <span :class="$store.state.activeType == 8 ? 'navActive' : ''"></span>
            </div>
            <div
                class="activeWrap"
                :class="$store.state.activeType == 13 ? 'activeStyle' : ''"
                @click="shouType(13)"
                :style="{ width: $store.state.activeType == 13 ? 'auto' : '125px' }"
              >
                云仓申请
                <span :class="$store.state.activeType == 13 ? 'navActive' : ''"></span>
                <span class="tag-new" v-if="$store.state.activeType !== 13">
                  <img :src="ossPath + '/pages/sharedWarehouse/tag_new.png'" alt="">
                </span>
              </div>-->
            <!-- <div
              id="clickHotEvents"
              class="activeWrap"
              :class="$store.state.activeType == 5 ? 'activeStyle' : ''"
              @click="shouType(5)"
            >
              热门活动
              <img src="@/assets/images/hotEvents/hot.gif" class="hot-tag">
              <span
                :class="$store.state.activeType == 5 ? 'navActive' : ''"
              ></span>
            </div>-->
            <!-- <div style="margin-left: 30px" v-if="newsTabsList.length">
              <el-dropdown class="common-nav__dropdown" trigger="hover">
                <span
                  class="el-dropdown-link"
                  style="font-size: 16px"
                  :style="
                    $store.state.setType ? 'color:#ffffff' : 'color:#ffffff'
                  "
                >
                  新闻中心
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <span
                  :class="$store.state.activeType == 5 ? 'navActive' : ''"
                ></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    class="dropdown-link"
                    v-for="item of newsTabsList"
                    :key="item.id"
                  >
                    <router-link
                      :to="{ name: 'news', query: { newType: item.id } }"
                      >{{ item.categoryName }}</router-link
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>-->
            <div
              class="activeWrap"
              :class="{
              'activeStyle': $store.state.activeType === 16,
              'activeStyle_Primary': $store.state.activeType === 16 && $store.state.setType,
              'hover-bg-white': !$store.state.setType,
              'hover-bg-primary': $store.state.setType
            }"
              @click="shouType(16)"
              @mouseenter="tabMouseEnter(16)"
            >
              会员专区
              <span :class="$store.state.activeType == 16 ? 'navActive' : ''"></span>
            </div>
          </div>

          <div v-if="!Authorization.token">
            <div class="loginBtn un-login">
              <span style="cursor: pointer" @click="openLogin(0)">登录</span>
              <span
                style="width: 1px;height: 13px;margin: 0 8px;background-color: #FFFFFF">
              </span>
              <span style="cursor: pointer" @click="openLogin(1)">免费注册</span>
              <!-- <span style="margin-left: 20px">
                <img src="../assets/icon_personal.png" alt />
              </span> -->
            </div>
          </div>
          <div v-if="Authorization.token" style="display: flex; align-items: center;margin-left: 32px;">
            <div>
              <!-- <div class="message-ico-wrap">
                <img :src="ossPath + '/pages/home/ico-message.png'" alt="">
                <span class="badge" v-if="Authorization.unReadNotificationCount = '9'">{{Authorization.unReadNotificationCount || 1}}</span>
              </div> -->
              <el-popover
                ref="messagePopover"
                placement="bottom-end"
                title=""
                width=""
                trigger="click"
                :popper-class="`message-popover ${routerType ? 'screenFull' : ''}`"
                v-model="messageVisible"
                content="">
                <div>
                  <message-list-box v-if="messageVisible" @hide="messageVisible = false"/>
                </div>
                <div class="message-ico-wrap" slot="reference">
                  <img :src="ossPath + ($store.state.setType ? '/pages/home/ico-message.png' : '/pages/home/ico-message-white.png')" alt="">
                <span class="badge" v-if="Authorization.unReadNotificationCount">{{Authorization.unReadNotificationCount}}</span>
              </div>
              </el-popover>

            </div>
            <div
              class="el-dropdown-link loginBtn login-status"
              style="font-size: 16px"
              :style="
                 $store.state.setType ?
                  'color:#141414' : 'color:#ffffff'
                "
            >
              <span
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 100px;
                "
              >{{ Authorization.namec||"-"}}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
              <span style="margin-left: 20px">
                <img style="width: 36px; border-radius: 36px" :src="Authorization && Authorization.headPortraitUrl ? Authorization.headPortraitUrl : defaultavater" alt />
              </span>
              <div class="login-info-t1">
                <p class="login-show" @click="PathTo('a')">个人中心</p>
                <p id="loginOut" class="login-show" @click="PathTo('c')">退出登录</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%;height: 70px"></div>
    <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <keep-alive>
      <router-view />
    </keep-alive>-->
    <loginType @openRegister="openRegister" ref="child"></loginType>
    <!-- 协议条款弹窗 -->
    <el-dialog title="服务条款" center :visible.sync="registerPolicyDialog" width="50%">
      <!-- <div v-html="registerContext" style="text-align: center;"></div> -->
      <div style>
        <p style="font-size: 26px">服务条款</p>
        <p>协议构成及须知</p>
        <p>
          1.
          本协议是货代拼网络平台注册用户（包括使用货代拼网络平台的个人和所代表的企业）与货代拼网络平台之间的法律契约，注册货代拼网络平台即代表接受本协议的约束，并自注册成功之时即成为本协议的一方（即货代拼用户）且自发出协议之时即受协议条款的约束。
        </p>
        <p>
          2.
          本协议受中华人民共和国法律管辖，签约地为深圳。下文中的货代拼是本协议的契约方之一。下文中的“用户”指货代拼网络平台注册用户，是本协议的契约方之另一方。
        </p>
        <p>
          3.
          用户欲访问和使用货代拼网络平台，必须事先认真阅读本协议中的各项条款，包括免除或者限制货代拼网络平台责任的免责条款及对用户的权利限制。请审阅并选择接受或不接受本协议。如不同意本协议条款或随时对其的修改，请不使用或主动取消货代拼网络平台提供的服务。对货代拼网络平台的使用行为将被视为对本协议条款的完全接受，包括接受货代拼网络平台对条款所做的任何修改。
        </p>
        <p style="font-size: 22px">用户使用规则</p>
        <p>
          1.
          货代拼网络平台服务仅限于为用户提供正常和合法业务工具，用户如果使用货代拼网络平台产品从事以下行为，即导致根本性违约，货代拼网络平台有权随时停止服务、解除本协议，并追讨因此带来的损失：
          1）有明确证据表明用户使用货代拼网络平台用于违反法律的业务。用户发送了任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽等内容的信息。
          2）对货代拼网络平台产品进行了任何形式的对其他第三方的再授权使用，销售或转让。
          3）提供的公司信息或个人资料不真实，或有可能对货代拼网络平台其他用户构成误导甚至欺诈。
          4）滥用货代拼网络平台产品的通信功能发送垃圾邮件和短信。
          5）对货代拼网络平台的连续服务和商誉构成损害的其他行为，包括对货代拼网络平台服务器的攻击。
          6）其他货代拼网络平台认为是不符合整体服务需求的特殊情形。
        </p>
        <p>
          2.
          货代拼网络平台使用用户所拥有的互联网域名所对应的电子邮件地址作为用户权证的唯一识别信息。当用户不再拥有在货代拼网络平台所登记的域名时，货代拼网络平台有权随时删除该用户的所有数据。
        </p>
        <p>
          3.
          用户必须自行配备上网和使用电信增值业务所需的设备，自行负担上网或第三方（包括但不限于电信或移动通信提供商）收取的通讯费、信息费等有关费用。如涉及电信增值服务的，请与您的电信增值服务提供商确认相关的费用问题。
        </p>
        <p style="font-size: 22px">知识产权</p>
        <p>
          1.
          用户完全拥有在使用货代拼网络平台时创建的数据和资料（包括但不限于：货物资料、价格数据、客户资料、联系人等信息）的所有权，并有权进行任何形式的处置，包括从货代拼网络平台中复制、导出和删除。
        </p>
        <p>
          2.
          亦邦（深圳）国际物流有限公司完全拥有货代拼网络平台的全部知识产权，用户签署本协议后并未拥有货代拼网络平台的所有权。亦邦（深圳）国际物流有限公司的公司名称、标志、LOGO、产品名字，以及货代拼网络平台的应用程序、源代码、界面设计、应用程序编程接口（API）等所关联的知识产权都归属亦邦（深圳）国际物流有限公司，未经授权不能使用。
        </p>
        <p>
          3.
          用户不得将涉及货代拼网络平台拥有知识产权的相关内容用于本协议范围以外的任何商业目的或泄露给第三方。用户不得出售、转售或复制货代拼网络平台产品，亦不可基于商业目的模仿货代拼网络平台的产品和服务。用户不可复制和模仿货代拼网络平台的设计理念、界面、功能和文字及图形说明。未经亦邦（深圳）国际物流有限公司许可，用户不得基于此协议所约定的服务对货代拼网络平台进行修改或制造、衍生其它产品。
        </p>

        <p style="font-size: 22px">数据安全及保密</p>

        <p>
          1.
          货代拼网络平台每天都对用户储存在货代拼服务器上的数据信息进行异地备份，做好冗灾预防机制，以确保在系统发生问题后，可以快速恢复系统正常运行。
        </p>
        <p>
          2.
          用户有义务维护自己在货代拼网络平台中的账户信息的完整性、密码的保密性。因用户维护或保密不善致使相关信息泄露，或由于第三方盗用用户帐号和密码进行各种操作而造成的损失，由用户自行负责。用户不得向他人提供货代拼网络平台的全部或部分服务，也不得容许他人通过自己的账户使用货代拼网络平台。
        </p>
        <p>
          3.
          货代拼的客服人员不接受用户的口头请求对其密码进行重置。对所有用户输入的信息和上传的文件，
          货代拼员工不能对其进行其他任何侵犯隐私的操作。
        </p>
        <p>
          4.
          用户对其输入数据的准确性、可靠性、合法性、适用性等自行负责。用户不可破坏货代拼网络平台的安全或授权措施，不可翻阅或存取非自己所有的数据。
        </p>
        <p>
          5.
          除应政府或司法机关调查或法律要求外，亦邦（深圳）国际物流有限公司直接口头或书面向第三方提供涉及用户在使用货代拼网络平台过程中保存在货代拼服务器上的数据的行为属于泄密行为，所造成对用户的直接损失，并经证实，用户有权通过法律途径要求货代拼按协议相应条款赔偿。
        </p>
        <p>
          6.
          本条款中的保密义务、权利和责任不适用于如下信息：(1)非由于货代拼不正当的原因已经为公众所知的；(2)由货代拼以外其他渠道被他人获知的信息，这些渠道并不受保密义务的限制；(3)经用户授权发布的信息;
          (4)由于法律、法院或其他国家有权机关的要求而披露的信息。
        </p>
        <p>
          7.
          货代拼保留使用汇总统计信息的权利，但这些信息是匿名，且不针对特定用户的。
        </p>
        <p>
          8.
          亦邦（深圳）国际物流有限公司保留面向基础版用户刊载广告的权利，这些广告刊载过程中将可能使用必要的定向技术来提高广告相关度，但货代拼不会将用户的个人信息透露给广告商，而只会在匿名的基础上通过自动化匹配技术实现广告优化刊载。
        </p>
        <p style="font-size: 22px">不可抗力及免责条款</p>
        <p>
          1.
          因一切不由货代拼可控因素引起的服务中断和长时间终止不属于货代拼违约，不承担赔偿责任。不可控因素包括但不限于：
          1）用户方客户终端硬件及网络，互联网络，机房供电系统故障；
          2）不可抗力： 地震、台风、洪水等自然灾害；
          战争、罢工、停电、政府行为等； 政府电力部门或电信部门的行为；
          电信线路被人为破坏或骨干网线路、设备因调试、扩容所引起的中断；
          INTERNET公网阻塞或其他通路（如访问目的地的服务器响应速度）问题；
          外部人为破坏因素引起的，超过安全设备的承载能力。
          3）其它不可预见、不可避免、不可克服和不可控制的不可抗力。
        </p>
        <p>遭受不可抗力的一方应采取一切必要措施减少损失，并在事件消除后协商恢复本合同的履行。</p>

        <p>
          2.
          货代拼不保证网址所载公开信息、软件演示和免费软件服务内容的准确性、可靠性或完整性，并明确地否认就该等信息和软件功能的错误或遗漏承担责任；并不对信息和免费软件做出任何种类的保证，包括（但不限于）有关没有侵犯第三方权利、所有权、适销性、质量令人满意、适合特定的用途和没有计算机病毒的保证。
        </p>
        <p>
          3.
          货代拼对任何损害概不负责，无论这些损害是否由于使用、不能使用本平台的结果或由连到本平台的任何Web网站或者任何这类网站中包含的信息所引起（包括但不限于由损失的利润、损失的数据或业务中断而造成的损害），也不管它们是否有保证、合同、侵权行为或任何其它法律根据以及事前已得到这类损害可能发生的消息。如果用户由于使用本站的免费信息和免费软件版本导致需要对设备或数据进行维护、修理或纠正，用户须承担由此而造成的所有费用。
        </p>
        <p>
          4.
          在任何情况下，货代拼对于与使用或未能使用本平台或任何链接的网站免费的内容、资料、软件功能有关任何直接的、间接的、特殊的、连带的或其它损失（包括但不限于任何利润损失、业务中断以及您的信息处理系统中的信息或程序或其它数据的丢失）不向任何机构承担责任。
        </p>
        <p>
          5.
          货代拼网络平台、论坛、博客中的所有言论并不代表货代拼的观点。这里所指的言论包括新闻及动态但不仅限于此。如果上面的言论对用户造成伤害，货代拼将协助您及有关部门依据相关法律法规清除相关内容并查找IP记录，但货代拼不承担任何责任。
        </p>
        <p style="font-size: 22px">条款修订</p>
        <p>
          1.
          货代拼有权随时对本协议的条款进行修订，并在修订生效日前三个工作日更新在货代拼网站。
        </p>
        <p>2. 修订的条款始终公开在货代拼网络平台条款页面</p>
        <p style="font-size: 22px">争议解决</p>
        <p>如果就本协议的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。本协议在执行过程中发生争议时，双方可协商解决；不能协商解决的，可向乙方所在地人民法院提起诉讼。在上述磋商或诉讼期间，双方应继续履行争议部分之外的本合同项下各自义务。</p>
      </div>
    </el-dialog>
    <serviceText ref="serviceText" v-show="!routerType" open-query-product-name></serviceText>
    <!-- 介绍页面 -->
    <div v-show="!routerType">
      <div class="advanCount">
        <div class="BottomWrap LR_center">
          <div class="Lf_center">
            <div class="qr_img" style="">
              <img
                style="width: 120px; height: 120px; border-radius: 10px;"
                :src="images.gzh"
                alt="微信公众号"
              />
              <p style="text-align: center; margin-top: 6px;margin-left:-5px; font-size: 16px">微信公众号</p>
            </div>

            <div class="qr_img">
              <img
                style="width: 120px; height: 120px; border-radius: 10px"
                :src="images.applet"
                alt="小程序"
              />
              <p style="text-align: center; margin-top: 6px;margin-left:-5px; font-size: 16px">微信小程序</p>
            </div>

            <!-- <div class="qr-content">
              <p class="qr-title">亦邦（深圳）国际物流有限公司</p>
              <div class="qr-sub-title">
                <span>亦邦（深圳）国际物流有限公司 版权所有</span>
              </div>
              <div class="qr-sub-title">
                <span @click="NewPop" class="BottomWrapPop RedColor">粤ICP备18003296号</span>
              </div>
            </div> -->
             <div class="company">
              <div class="company-name">航迅（深圳）网络科技有限公司</div>
              <a class="company-info" href="https://beian.miit.gov.cn/">粤ICP备2021075559号</a>
              <div class="company-tel">航迅（深圳）网络科技有限公司 版权所有</div>
            </div>

          </div>

          <div class="rf_center">
            <p class="form-title">联系我们</p>
            <p class="form-title-top">我们将尽快安排专属您的客服与您对接</p>

            <el-form
              :model="numberValidateForm"
              ref="numberValidateForm"
              :rules="numberValidateFormRule"
              style="margin-top:10px"
            >
            <el-row>
              <el-col :span="18" >
                <el-form-item prop="tel">
                <el-input
                  placeholder="请输入您的联系方式"
                  v-model="numberValidateForm.tel"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              </el-col>
              <el-col :span="6" >
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('numberValidateForm')"
                >提交</el-button>
              </el-form-item>
              </el-col>
            </el-row>



            </el-form>
          </div>
        </div>
      </div>
    </div>

    <!-- 查询轨迹引导 -->
    <div class="look-tips" v-if="isCover">
      <div class="look-content">
        <img class="look-img" src="@/assets/look.png" alt />
        <div class="look-header">查询轨迹</div>
        <div class="look-finish" @click="handleEnd"></div>
        <div class="look-finish-1" @click="handleEnd"></div>
      </div>
    </div>

  </div>
</template>

<script>
// import Driver from "driver.js";
import qs from "qs"
import loginType from "../../common/loginType"
import serviceText from "../../common/serviceText"
import Utils from "../../common/util.js"
import TrajectoryVue from "./placeOrder/Trajectory.vue"
import { loginSaveUserData, loginOut } from "@/assets/js/utils.login"
import { mapState } from "vuex"
import {isObject, sendCustomerOperationRecord} from "../assets/js/utils"
import {qrCodeImages} from "../../devParams.js";
import { ossPath } from "../../devParams.js"
import messageListBox from './PersonalCenter/components/message-list-box'
import { debounce, throttle } from 'my-tools-kit'
const defaultavater = require('../assets/icon_personal.png')
export default {
  name: "index",
  components: {
    loginType,
    serviceText,
    messageListBox
  },
  data () {
    var validatePass = (rule, value, callback) => {
      if (value !== this.userForm.password) {
        callback(new Error("两次输入密码不一致!"))
      } else {
        callback()
      }
    }
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/
      if (!value) {
        return callback(new Error("电话号码不能为空"))
      }
      setTimeout(() => {
        // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
        // 所以在前面加了一个+实现隐式转换

        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error("电话号码格式不正确"))
          }
        }
      }, 100)
    }

    var checkEmail = (rule, value, callback) => {
      const mailReg =
        /^[\da-z]+([\-\.\_]?[\da-z]+)*@[\da-z]+([\-\.]?[\da-z]+)*(\.[a-z]{2,})+$/
      if (!value) {
        return callback(new Error("邮箱不能为空"))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error("请输入正确的邮箱格式"))
        }
      }, 100)
    }

    return {
      defaultavater,
      ossPath,
      images: qrCodeImages,
      HeaderCount: {},
      indexBGshow: true,
      isCover: false,
      isShow: false, //
      driverIndex: null, // 指引
      // register data
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        phoneNo: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        comPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],

        verificationCode: [
          {
            type: "number",
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        // verificationCode: [
        //   { required: true, message: "请输入验证码", trigger: "blur" },
        // ],
      },
      registerPolicyDialog: false,

      // register data end

      checked: true,
      activeName: "first",
      countDown: 0,
      timer: "",
      userForm: {
        cusType: "",
        email: "",
        name: "",
        password: "",
        comPassword: "",
        phoneNo: "",
        verificationCode: "",
      },
      dialogFormVisible: false,
      routerType: false,
      prefix: "",
      goodsTypeId: "", //当前选择的货物类型
      guojiaData: null, //选择的国家
      Citydata: null, //选择的城市
      cangkuitem: null, //仓库
      houseHis: [],
      newsTabsList: [{ id: "", categoryName: "新闻资讯" }], //新闻分类
      numberValidateForm: {
        tel: "",
      },
      numberValidateFormRule: {
        tel: [
          { required: true, message: "请输入联系电话", trigger: "change" },
          { validator: checkPhone, trigger: "change" },
        ]
      },
      messageVisible: false,
      valueAddedServiceMenuList: [
        { name: '供应链金融', describe: '随借随还,审批快速,解决货代垫款压力', icon: ossPath + '/pages/userCenter/icon_supplier_chain_finance.png', type: 8, pageName: 'supplyChainFinanceApply' },
        { name: '全球专线联盟云仓', describe: '不用自己租仓,使用共享仓,助力全国收货', icon: ossPath + '/pages/userCenter/icon_cloud_warehouse.png', type: 13, pageName: 'platformSharedWarehouse' },
        // {
        //   // name: '一明TMS', describe: '24H极速拥有您的专属物流商城和品牌官网以及智慧物流系统',
        //   name: '跨境物流系统', describe: '该系统由全球专线联盟软件合作伙伴一明科技提供', link: 'https://www.yimingsaas.com/',
        //   icon: ossPath + '/pages/userCenter/icon_SAAS_new.png', type: 14
        // },
      ],
      pageScrollY: 0,
      beforeHoverActiveIndex: 1
    }
  },
  watch: {
    "$store.state.isCover" (newVal, oldVal) {
      // this.isShow = true
      console.log("store---", newVal, oldVal, this.$store.state.isShow)
      if (newVal) {
        this.isCover = newVal
      }
    },
    "$route.path": {
      immediate: true,
      handler (path) {
        if (this.Authorization && this.Authorization.token) {
          this.axios.get(`/user/getUserLoginInfo/1`).then(res => {
            this.$store.commit("addUserdata", res.data.data)
          }).catch(() => {
            this.$message.warning('获取当前用户最新信息失败')
          })
        }
        const newsList = [
          "/news",
        ]
        if (newsList.includes(path)) {
          this.$store.commit("changeactive", 12)
        }
        let topNavCenterList = [
          "/",
          "/placeOrder/introduce",
          "/placeOrder/brandIntroduce",
          "/news",
          "/newsDetails",
          "/404",
          "/placeOrder/Trajectory",
          "/placeOrder/Guide",
          "/news",
          "/placeOrder/placeindexInfo/queryPrice",
          "/placeOrder/placeindexInfo/Smallbag",
          "/hotEvents",
          "/placeOrder/supplierJoin",
          "/placeOrder/supplyChainFinanceApply",
          "/placeOrder/platformSharedWarehouse",
          "/placeOrder/saas",
          "/placeOrder/placeindexInfo/inquiryHall",
          "/placeOrder/publishedInquiry",
          "/placeOrder/publishedInquiry/publishedSuccess",
          "/placeOrder/inquiryTakeOrder",
          "/placeOrder/inquiryTakeOrder/success",
          "/placeOrder/MemberZone",
          "/placeOrder/MemberZoneDetail",
        ]
        if (topNavCenterList.includes(path)) {
          this.routerType = false
        } else {
          this.routerType = true
        }
        if (path.includes('/PersonalCenter/Personalindex')) {
          this.$store.commit('changeHeadType', 1)
        }

        if (path === "/" || path === "/placeOrder/platformSharedWarehouse" || path === "/placeOrder/saas") {
          this.indexBGshow = true
        } else if (path === '/placeOrder/introduce') {
          this.$store.commit("changeSetType", true)
        } else if (path === '/placeOrder/MemberZone') {
          this.$store.commit("changeSetType", true)
        } else if (path === '/placeOrder/MemberZoneDetail') {
          this.$store.commit("changeSetType", true)
        } else {
          this.indexBGshow = false
          this.$store.commit("changeSetType", true)
        }
        if (['/placeOrder/placeindexInfo/inquiryHall',
        '/placeOrder/publishedInquiry',
        '/placeOrder/inquiryTakeOrder',
        '/placeOrder/inquiryTakeOrder/success'].includes(this.$route.path)) {
          this.$nextTick(() => {
            this.$refs.serviceText.ActiveIndex = 0
          })
        } else {
          this.$nextTick(() => {
            this.$refs.serviceText.ActiveIndex = 1
          })
        }
      },
    },
  },
  computed: {
    ...mapState(["Authorization"]),
    logoUrl () {
      return this.$store.state.logo
    }
  },
  //方法集合
  methods: {
    myclick () {
      console.log("this.$route.path: ", this.$route.path)
    },
    // 隐藏
    handleEnd () {
      this.isCover = false
    },
    shouType (num) {
      if (num == 1) {
        this.$router.push("/")
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //打开logo
      }
      else if (num == 2) {
        //轨迹查询
        sendCustomerOperationRecord("轨迹查询");
        this.$router.push({ name: "Trajectory" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      else if (num == 3) {
        //平台介绍
        sendCustomerOperationRecord("平台介绍");
        this.$router.push({ name: "Introduce" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      else if (num == 4) {
        //用户指南
        sendCustomerOperationRecord("用户指南");
        this.$router.push({ name: "Guide" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      else if (num == 5) {
        // 热门活动
        sendCustomerOperationRecord("热门活动");
        this.$router.push({ path: "/hotEvents" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      else if (num == 6) {
        // 专线大厅
        sendCustomerOperationRecord("专线大厅");
        this.$router.push({ path: "/placeOrder/placeindexInfo/queryPrice" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      else if (num == 7) {
        // 平台入驻
        sendCustomerOperationRecord("平台入驻");
        this.$router.push({ name: "supplierJoin" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      else if (num == 8) {
        // 供应链金融
        sendCustomerOperationRecord("供应链金融");
        this.$router.push({ name: "supplyChainFinanceApply" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      else if (num == 11) {
        // 品牌介绍
        sendCustomerOperationRecord("品牌介绍");
        this.$router.push({ name: "brandIntroduce" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      else if (num == 12) {
        // 新闻中心
        sendCustomerOperationRecord("新闻中心");
        this.$router.push({ path: "/news" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      else if (num == 13) {
        sendCustomerOperationRecord("平台共享仓");
        this.$router.push({ name: "platformSharedWarehouse" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //打开logo
      }
      else if (num === 14) {
        sendCustomerOperationRecord("一明TMS");
        this.$router.push('/placeOrder/saas')
        this.$store.commit("changeSetType", false)
        this.$store.commit("changeLogoshow", true) //关闭logo
      }
      else if (num === 15) {
        // 整柜询盘
        sendCustomerOperationRecord("整柜询盘");
        this.$router.push({ path: "/placeOrder/placeindexInfo/inquiryHall" })
        // this.$store.commit("changeSetType", false)
        // this.$store.commit("changeLogoshow", true) //关闭logo
      }
      else if (num === 16) {
        // 会员专区
        if (!this.Authorization.token) {
          this.openLogin(0)
          return
        }
        sendCustomerOperationRecord("会员专区");
        this.$router.push({ name: "MemberZone" })
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeLogoshow", false) //关闭logo
      }
      if ([2, 3, 6, 7, 8, 15, 16].includes(num)) {
        this.$store.commit('changeHeadType', 2)
      } else {
        this.$store.commit('changeHeadType', 1)
      }
      this.beforeHoverActiveIndex = num
      this.$store.commit("changeactive", num)
      this.$store.commit("emptyList") //清空个人中心标签
      Utils.$emit("changeNav", num)
    },
    /* // jack start */
    openRegister () {
      // 显示注册弹窗
      this.dialogFormVisible = true
    },
    // 协议条款弹窗
    toPolicy () {
      this.registerPolicyDialog = true
    },
    /* // jack end */

    logonShow () {
      this.dialogFormVisible = true
    },
    handleClick (tab, event) {
      this.tabName = tab.name
      for (let key in this.userForm) {
        this.userForm[key] = ""
      }
      console.log(tab.name)
    },
    openLogin (num) {
      this.$store.state.tag = 1
      this.$refs.child.showDialog(num)
    },
    pathIndex () {
      this.$store.commit("emptyList") //清空个人中心标签
      this.$router.push("/")
      this.shouType(1)
    },
    PathTo (command) {
      console.log("123456", command)
      if (command == "a") {
        sendCustomerOperationRecord("个人中心")
        //个人中心 - 默认首页
        let pathData = {
          code: "",
          icon: "",
          level: "",
          name: "",
          nextNodes: "",
          parentId: "",
          resourceId: "",
        }
        pathData.code = `/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow`
        pathData.name = `我的钱包`
        this.$store.commit("mutationSelectTags", pathData)
        this.$router.push(
          `/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow`
        )

        // this.$router.push({
        //   name: "userCountshow",
        // });
        this.$store.commit("changeSetType", true)
        this.$store.commit("changeactive", 0)
        this.$store.state.tag = 1
      } else if (command == "b") {
        this.$router.push("/")
        this.$store.commit("changeSetType", false)
        this.$store.commit("changeactive", 1)
      } else if (command == "c") {
        sendCustomerOperationRecord("退出登录")
        // debugger
        sessionStorage.removeItem("tagType")

        //退出
        // this.shouType()
        this.$confirm("确定退出并返回吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.state.tag = 2
            const excludedPaths = [
              "/",
              "/placeOrder/introduce",
              "/404",
              "/placeOrder/Trajectory",
              "/placeOrder/placeindexInfo/queryPrice",
              "/placeOrder/placeindexInfo/Smallbag",
              "/placeOrder/Guide",
              "/news",
              "/newsDetails",
              "/NewOrder/newBillCargo",
              "/placeOrder/platformSharedWarehouse",
              "/placeOrder/saas",
              "/placeOrder/supplyChainFinanceApply",
              "/placeOrder/supplierJoin",
              "/placeOrder/placeindexInfo/inquiryHall",
              "/placeOrder/inquiryTakeOrder",
              "/placeOrder/publishedInquiry",
              "/takeOrder",
              "/placeOrder/MemberZone"
            ];
            if (!excludedPaths.includes(this.$route.path)) {
              loginOut()
              this.$router.push("/index")
              // this.$router.go(0)
            } else {
              loginOut()
              const unLoginPages = ['/placeOrder/inquiryTakeOrder', '/placeOrder/publishedInquiry', '/takeOrder',"/placeOrder/MemberZone"]
              if (unLoginPages.includes(this.$route.path)) {
                this.$router.push("/")
                this.shouType(1)
                this.$store.commit("changeSetType", false)
              }
              this.visiable = false
              this.codeShow = false
            }
            //   loginOut();
            // this.$router.push("/");
            // this.shouType(1);
            // this.$store.commit("changeSetType", false);
            // this.visiable = false;
            // this.codeShow = false;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            })
          })
      } else if (command == "d") {
        this.$router.push("/")
      }
    },
    NewPop () {
      window.open("https://beian.miit.gov.cn/")
    },

    // openUser(){
    //    window.open("http://doc.18jiuyu.com/web/#/1/1");
    // },
    /**
     * 获取 新闻分类list
     */
    getNewsTabsList () {
      let data = { appCode: "huodainews", /* 新闻模块的 */ }
      return this.axios
        .post("/cms/findCategoryList", qs.stringify(data))
        .then((res) => {
          console.log("list: ", res)
          if (res.data.code !== 1) {
            return Promise.reject(new Error(res.data.message || "服务器繁忙"))
          }
          let list = res.data.data || []
          if (list.length) this.newsTabsList = list
          return list
        })
        .catch((res) => {
          console.error(res)
          // this.$message.error(res.message||'服务器繁忙，请稍后再试！');
          // this.loading = false;
          // this.newsTabsList = [];
        })
    },

    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            phone: this.numberValidateForm.tel,
            remark: ''
          }
          this.axios.post('/customer/saveCustomerConsultationInfo', params).then((res) => {
            if (res.data.code == 200) {
              this.$message({ message: '已提交成功，我们将尽快安排服务人员与您对接', type: 'success' })
              this.$refs[formName].resetFields()
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    clickHotEvents () {
      if (typeof window._hmt === "object") {
        console.log("发送统计【热门活动浏览数】")
        window._hmt.push(['_trackEvent', 'click_hot_events_menu', 'click'])
        window._hmt.push(['_trackEvent', '热门活动浏览数', "click"])
      }
      const userKey = this.carryLoginInfo()
      let url = location.origin + "/hotEvents"
      if (userKey) url += `?U=${userKey}`
      window.open(url)
      // this.$router.push({ path: '/hotEvents' })
    },
    /**
     * 携带登录信息：存在登录信息时存入 localStorage ，并返回key
     * @returns {string}
     */
    carryLoginInfo () {
      const userInfo = this.$store.state.Authorization
      if (!isObject(userInfo)) return ""
      if (!userInfo.token) return ""
      const k = "u_" + Date.now()
      localStorage.setItem(k, JSON.stringify(userInfo))
      return k
    },
    /**
     * 进入页面时修正头部导航tab current
     */
    initTopNavTabsCurrent () {
      const path = this.$route.path
      const pathMapNum = {
        "/placeOrder/introduce": 3,
        "/placeOrder/Trajectory": 2,
        // "/placeOrder/Guide": 4,
        "/placeOrder/MemberZone": 16,
        "/hotEvents": 5,
      }
      const num = pathMapNum[path]
      if (num) this.shouType(num)
    },
    clickMenu(item) {
      if (item.link) {
        return window.open(item.link, '_blank')
      }
      const type = item.type
      this.shouType(type)
      if ([7, 8, 13].includes(type)) {
        this.$store.commit('changeHeadType', 2)
      } else {
        this.$store.commit('changeHeadType', 1)
      }
    },
    tabMouseEnter(index) {
      this.$store.commit('changeactive', index)
    },
    tabMouseLeave() {
      this.$store.commit('changeactive', this.beforeHoverActiveIndex)
    },
    headEnter() {
      this.beforeHoverActiveIndex = this.$store.state.activeType
    }
  },
  created () {
    this.initTopNavTabsCurrent()
    if (this.$route.path != "/") {
      // this.routerType = true
      this.indexBGshow = false
      this.$store.commit("changeSetType", true)
    } else {
      this.routerType = false
      this.indexBGshow = true
      this.$store.commit("changeSetType", false)
    }
    this.getNewsTabsList()
    window.addEventListener('scroll', () => {
      this.pageScrollY = window.scrollY
      const activeType = this.$store.state.activeType
      if (this.pageScrollY > 0) {
        this.$store.commit('changeSetType', true)
        if ([1,2,6,7,3,8,13,14,15].includes(activeType) || this.$route.path.includes('/publishedInquiry') || this.$route.path.includes('/inquiryTakeOrder')) {
          this.$store.commit('changeHeadType', 2)
        }else {
          this.$store.commit('changeHeadType', 1)
        }
      } else {
        // if ([1,14].includes(activeType) && !this.$route.path.includes('/publishedInquiry') && !this.$route.path.includes('/inquiryTakeOrder')) {
        //   this.$store.commit("changeSetType", false)
        //   this.$store.commit("changeLogoshow", true)
        // } else {
        //   this.$store.commit("changeSetType", true)
        //   this.$store.commit("changeLogoshow", false)
        // }
        // if ([2,3,6,7,8,13,15].includes(activeType) || this.$route.path.includes('/publishedInquiry') || this.$route.path.includes('/inquiryTakeOrder')) {
        //   this.$store.commit('changeHeadType', 2)
        // }else {
        //   this.$store.commit('changeHeadType', 1)
        // }
          console.log([1,14].includes(activeType))
        if ([14].includes(activeType)) {
          const inquiryPages = ['/placeOrder/inquiryTakeOrder', '/placeOrder/publishedInquiry', '/placeOrder/inquiryTakeOrder/bulkCargo']
          if (inquiryPages.includes(this.$route.path)) {
              this.$store.commit('changeSetType', true)
          } else {
              this.$store.commit('changeSetType', false)
          }
        } else {
          this.$store.commit("changeSetType", true)
        }
      }
    })
  },
  mounted () {
    if (this.$route.query.qrCode) {
      let data = {
        code: this.$route.query.qrCode,
      }
      this.axios
        .post(`/user/loginByWechatCode`, qs.stringify(data))
        .then((resData) => {
          if (resData.data.code == 200) {
            this.$store.state.Authorization = resData.data.data
            this.info = resData.data.data
            // // debugger
            // if(resData.data.data.isBindedWebOpenId){
            //    this.visiable = false
            // }
            localStorage.setItem(
              "Authorization",
              JSON.stringify(resData.data.data)
            )
            sessionStorage.setItem(
              "Authorization",
              JSON.stringify(resData.data.data)
            )
            const mobilePhone = JSON.stringify({
              account: resData.data.data.mobilePhone,
              activeName: 0
            })
            localStorage.setItem('login-account', mobilePhone)
            this.$message({
              type: "success",
              message: "登录成功",
            })
            //  console.log('resData.data.data.isBindedWebOpenId: ', resData.data.data.isBindedWebOpenId);
            //           if(resData.data.data.isBindedWebOpenId){

            //             this.visiable = true
            //           }
          } else {
            this.$message({
              type: "error",
              message: resData.data.message,
            })
          }
        })
    } else {
      // debugger
      let dataRes = JSON.parse(localStorage.getItem("Authorization"))
      if (dataRes && !dataRes.isBindedWebOpenId) {
        this.visiable = true
      }
    }
    // 没有绑定微信登录
    if (this.$route.query.loginMsg) {
      this.$message({
        type: "error",
        message: this.$route.query.loginMsg,
      })
      // this.$router.push("/")
      setTimeout(() => {
        this.$router.push("/")
      }, 3000)
    }
  },
};
</script>
<style>
.message-popover.el-popper {
  margin-top: 30px !important;
  padding: 15px 0;
  border-radius: 8px;
  /* left: 1045px !important; */
  left: calc((100vw - 1200px) / 2 + 690px) !important;
  top: 50px!important
}
@media (max-width: 1700px) {
  .message-popover.el-popper {
    left: calc(((100vw - 1200px) / 2 + 670px) / 0.8) !important;
  }
}
.screenFull.message-popover.el-popper {
  left: auto !important;
  right: 60px
}
.message-popover.el-popper .popper__arrow {
  display: none;
}
.service-list.el-popper {
  /* margin-top: 22px !important; */
  margin-top: 0 !important;
  padding: 17px 100px 21px !important;
  box-sizing: border-box;
  top: 80px !important;
  left: 50% !important;
  transform: translateX(-50%);
}
</style>
<style scoped>
/* .indexBg {
  background: url("../assets/banner_static.png") no-repeat center center;
} */
.indexBg {
  /* background: url('../assets/banner_bg.gif') no-repeat center center; */
  /* background: url('../assets/banner_bg.png') no-repeat top center; */
}

.activeWrap.activeStyle {
  /* color: #ffffff; */

  /* color: #FF4D01;
  background-color: white;
  border-radius: 5px; */
  font-weight: 600;
  height: 68px;
  border-bottom: 2px solid #FFFFFF;
}
.activeWrap.activeStyle_Primary {
  /* color: #FFFFFF;
  background-color: #983A41;
  border-radius: 5px; */
  font-weight: 600;
  height: 68px;
  border-bottom: 2px solid #FF4D01;
}
.activeWrap {
  position: relative;
  /* height: 36px;
  line-height: 36px;
   */
  height: 70px;
  line-height: 80px;
  /* padding: 0 6px; */
  float: left;
  font-size: 16px;
  font-weight: 400;
  /* margin-left: 15px; */
  margin-left: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.activeWrap2 {
  position: relative;
}
.navActive {
  /* position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #ffffff;
  border-radius: 2px; */
}
.loginBtn {
  color: #ffffff;
  margin-left: 20px;
  text-align: center;

  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;

  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.un-login {
  min-width: 90px;
  padding: 0 6px;
  height: 32px;
  background: #FF4D01;
  border-radius: 100px;
}
.zhuce {
  background: #ff7200;
  cursor: pointer;
  border: 1px solid #ff7200;
  width: 100px;
  height: 35px;
  line-height: 35px;
  color: #ffffff;
  margin-right: 10px;
  text-align: center;
  float: left;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.Count {
  background-size: cover;
  width: 100%;
  height: 100%;
}
.OldBackground {
  background: #ffffff;
  width: 100%;
  height: 100%;
}

.header {
  margin: 0 auto;
  height: 70px;
  box-sizing: border-box;
  z-index: 9999;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  /* justify-content: center; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
}
.showType {
  /* background: #FF4D01; */
  width: 100%;
  padding: 16px 67px;
  /* color: #ffffff; */
}
.wrap_l {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.wrap_R {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  /* justify-content: center; */
  /* flex-direction: column; */
}
.center_Style {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.advanCount {
  float: left;
  min-width: 1021px;
  width: 100%;
  height: 240px;
  background: #252525;
}
.BottomWrap {
  color: #ffffff;
  width: 80%;
  margin: 0 auto;
  text-decoration: none;
}
.BottomWrapPop {
  cursor: pointer;
}
.RedColor:hover {
  color: #b92d3d;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.Lf_center {
  width: 64%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-right: #FFFFFF solid 1px ;
}

.qr_img {
  width: 16%;
  height: 100%;
}

.qr-content {
  width: 60%;
  height: 100%;
  padding: 10px 0;
}
.qr-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 50px;
  color: #fff;
}

.qr-sub-title {
  display: flex;
  white-space: nowrap;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.56);
  margin-bottom: 10px;
}

/* .rf_center {
  width: 26%;
  height: 100%;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(175, 175, 175);
  border-image: initial;
  border-radius: 12px;
  background: rgba(22, 23, 24, 0.4);
  padding: 10px 40px 0px;
  box-sizing: border-box;
} */
.rf_center {
  width:400px;
  height: 100%;
  border-color: rgb(175, 175, 175);
  padding: 10px 40px 0px;
}

.form-title {
  font-size: 30px;
  font-weight: 700;
  color: #fff;
}

.form-title-top {
  margin-top: 10px;
  font-size: 14px;
}

/* .friendShip_link {
  width: 100%;
  height: 50px;
  margin-top: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 18px;
}
.friendShip_link span a:hover {
  color: #b92d3d;
}

.friendShip_link span a {
  text-decoration: none;
} */
.title {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #fff;
  padding: 0 3px;
}
.foot_Box {
  width: 80%;
  border-top: 1px solid #888;
  float: left;
  /* padding: 10px 0; */
  box-sizing: border-box;
  height: 60px;
  line-height: 60px;
}
</style>

<style lang="scss" scoped>
.code-binding {
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 90px;
  background: #313131;
  opacity: 0.8;
  z-index: 999999;
  .code-info {
    width: 24%;
    margin: auto;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: space-around;
    color: white;
    min-width: 500px;
    .code-title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    .code-des {
      margin-top: 5px;
    }
  }
  .code-right img {
    width: 50px;
    height: 50px;
  }
  .code-cancel {
    position: absolute;
    top: 10px;
    right: 20px;
  }
}

.code-fixed {
  position: fixed;
  bottom: 100px;
  img {
    width: 100px;
  }
}

.tips {
  position: relative;
  width: 100%;
  height: 30px;
  background: white;
}

.login-wx-code {
  text-align: center;
  margin-top: -35px;
}
</style>
<style scoped lang="less">
.dropdown-link {
  padding: 0;
  a {
    padding: 0 20px;
    display: block;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    color: inherit;
    &:hover {
      text-decoration: none;
    }
  }
}
</style>

<style scoped>
div#driver-popover-item .scoped-class {
  left: 1290px !important;
}

.look-enter {
  position: relative;
  background: #6f4f52;
}

.look-tips {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  z-index: 999999;
  opacity: 0.8;
}
/*
.look-content {
    width: 200px;
    height: 50px;
    background: red;
    position: absolute;
    right: 289px;
    top: 73px;
    background: linear-gradient(
180deg, #FFF, #FFE1E4) !important;
    border-radius: 5px;
    z-index: 999999;
} */

img.look-img {
  position: absolute;
  right: 324px;
  top: 22px;
}

.look-header {
  position: absolute;
  right: 354px;
  color: white;
  background: #FF4D01;
  top: 27px;
  width: 76px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
}
.look-finish-1 {
  position: absolute;
  top: 99px;
  width: 30px;
  height: 30px;
  right: 330px;
  cursor: pointer;
}

.look-finish {
  position: absolute;
  width: 70px;
  height: 32px;
  /* background: red; */
  right: 345px;
  top: 146px;
  cursor: pointer;
}

.login-wx-code-1 {
  margin-left: -100px;
  transform: scale(0.25);
}

.show-t1 {
  position: relative;
}
.show-t2 {
  position: absolute;
  /* right: 92
px
; */
  top: 146px;
  width: 300px;
  height: 300px;
  background: red;
  /* bottom: 0; */
  z-index: 100;
  opacity: 0;
  border: 1px solid red;
  margin-top: -100px;
}

.code-right {
  margin-top: 212px;
}
#wx_login_container {
  margin-top: -196px !important;
}

.foot_Box,
.LR_center {
  max-width: 1200px;
}
</style>

<style lang="scss" scoped>
.BottomWrap.LR_center {
  margin-top: 50px;
  margin-bottom: 16px;
}
.imgs-phone {
  width: 21px;
  height: 23px;
  vertical-align: middle;
}

.login-status {
  display: flex;
  align-items: center;
  font-size: 16px;
  position: relative;
  cursor: pointer;
  height: 80px;
  z-index: 100;
}
.login-info-t1 {
  display: none;
  border-radius: 8px;
  overflow: hidden;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  width: 120px;
  position: absolute;
  height: 80px;
  background: white;
  color: #606266;
  top: 80px;
  right: 0;
  background-color: #fff;
  text-align: center;
  box-shadow: 0px 0px 39px 5px rgba(208, 208, 208, 0.32);
  border: 1px solid rgb(233, 231, 231);
}
.login-show {
  height: 40px;
  line-height: 40px;
}
.login-show:hover {
  background: #FCF4F1;
  color: #FF4D01;
}
.login-status:hover .login-info-t1 {
  display: block;
}

.hot-tag {
  position: absolute;
  z-index: 1;
  right: -23px;
  bottom: 90%;
  display: block;
  width: 34px;
  height: 17px;
}
.company{
  width: 60%;
  &-name{
    font-size: 22px;
    font-weight: bold;
  }
  &-info{
    display: block;
    color: white;
    margin-top: 30px;
    font-size: 16px;
    font-weight: 500;
  }
  &-tel{
    margin-top: 13px;
    font-weight: 500;
    font-size: 16px;
  }
}

.color_black {
  color: #000;
}
.back_black {
  background: #000 !important;
}
.tag-new {
  position: absolute;
  top: -10px;
}
.tag-hot {
  position: absolute;
  top: -10px;
  right: -2px;
}
.message-ico-wrap {
  position: relative;
  padding-top: 2px;
  width: 24px;
  height: 22px;
  text-align: center;
  line-height: 24px;
  background: transparent;
  border-radius: 2px;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
  img {
    width: 14px;
    height: 17px;
  }
  .badge {
    position: absolute;
    padding: 3px;
    right: -40%;
    top: -4px;
    min-width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    background-color: #FF0101;
    color: #FFFFFF;
    font-size: 12px;
    border-radius: 20px;
    zoom: 0.9;
  }
}
.value-add-service-list {
  //padding: 20px;
  display: flex;
  justify-content: space-between;
  .menu-item {
    width: 300px;
    height: 80px;
    padding: 10px 16px 10px 10px;
    border-radius: 4px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    transition: background-color .3s ease;
    cursor: pointer;
    &:hover {
      background: #FCF4F1;
    }
    &-title {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      margin-bottom: 2px;
    }
    &-describe {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
  }
}
.value-add-title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #141414;
  line-height: 22px;
}
.value-add-divider {
  width: 1000px;
  height: 1px;
  background: #EEEEEE;
  margin: 17px 0 19px;
}
.hover-bg-white:hover {
  // background-color: #FFFFFF !important;
  // color: #FF4D01 !important;
  // border-radius: 4px;
  // transition: background-color .5s ease;
  font-weight: 600;
  transition: border-color .25s ease;
  border-bottom: 2px solid #FFFFFF;
}
.hover-bg-primary:hover {
  // background-color: #983A41 !important;
  // color: #FFFFFF !important;
  // border-radius: 4px;
  // transition: background-color .5s ease;
  font-weight: 600;
  transition: border-color .25s ease;
  border-bottom: 2px solid #FF4D01;
}
.border-bottom {
  border-bottom: 1px solid #EEEEEE;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue